import * as React from "react";
import { UitkSecondaryButton } from "uitk-react-button";
import { AnalyticsConfig } from "uitk-react-utils";
import { Action, FlexTrackingInfo, sendDelayedTrackEvent } from "components/utility/analytics/FlexAnalyticsUtils";
import { inject } from "mobx-react";
import { useLocalization } from "@shared-ui/localization-context";
import { ViewWhereToStayGuideButtonProps } from "../typings";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";

const ViewWhereToStayGuideButton = inject("analytics")((props: ViewWhereToStayGuideButtonProps) => {
  const { href, analytics } = props;
  const { formatText } = useLocalization();
  /* istanbul ignore next line */
  const analyticsConfig: AnalyticsConfig = {
    id: "TG.LP.Dest.WhereToStay.ReadGuide",
    callback: (id) => {
      const flexTrackingInfo: FlexTrackingInfo = {
        moduleName: id,
        action: Action.CLICK,
        linkName: "WhereToStayGuide",
      };
      sendDelayedTrackEvent(flexTrackingInfo, analytics);
    },
  };

  return (
    <UitkSpacing margin={{ blockstart: "three" }}>
      <UitkLayoutFlex justifyContent="center">
        <UitkLayoutFlexItem>
          <UitkSecondaryButton href={href} tag="a" analytics={analyticsConfig}>
            {formatText("destinationNeighborhood.seeWhereToStayGuide")}
          </UitkSecondaryButton>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    </UitkSpacing>
  );
});

export default ViewWhereToStayGuideButton;
